import { http } from '@/lib/http'
import { ORDER_PAYMENT_PROVIDERS } from '@/features/subscription/subscription.api'
import type { LeaseFeeQuote, LeasePaymentInit, PaymentConfirmStatus, PaymentValidateResult } from '@/types/models'

export const leasePaymentApi = {
  /** The fee for a lease of this length — the only source of truth for the free-lease allowance. */
  /** With `promoCode` (LP-1001) the quote says what the code did, or why it couldn't, under `promo`. */
  feeEstimate: (duration: number, frequency: string, promoCode?: string) =>
    http.post<LeaseFeeQuote>('/leases/fee-estimate', promoCode ? { duration, frequency, promoCode } : { duration, frequency }),
  initiate: (leaseId: string) => http.post<LeasePaymentInit>(`/leases/${leaseId}/payment`, { paymentProviders: ORDER_PAYMENT_PROVIDERS }),
  status: (leaseId: string) => http.get<PaymentConfirmStatus & { leaseId: string; leaseStatus: string }>(`/leases/${leaseId}/payment-status`),
  validate: (leaseId: string) => http.get<PaymentValidateResult & { leaseId: string; leaseStatus: string }>(`/leases/${leaseId}/payment-validate`),
  cancel: (leaseId: string, paymentToken: string) => http.delete<null>(`/leases/${leaseId}/payment`, { data: { paymentToken } }),
}
